<template>
  <div class="p-3">
    <h5 class="mb-3">{{ $t("shop.urssaf.form.title") }}</h5>

    <span class="mb-3">{{ $t("shop.urssaf.form.description") }}</span>

    <form @submit.prevent="onSubmit">
      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label">{{ $t("shop.urssaf.form.firstName") }}</label>
          <input v-model.trim="form.first_name" class="form-control" required />
        </div>

        <div class="col-md-4">
          <label class="form-label">{{ $t("shop.urssaf.form.lastName") }}</label>
          <input v-model.trim="form.last_name" class="form-control" required />
        </div>

        <div class="col-md-4">
          <label class="form-label">{{ $t("shop.urssaf.form.companyName") }}</label>
          <input v-model.trim="form.company_name" class="form-control" required />
        </div>

        <div class="col-md-8">
          <label class="form-label">{{ $t("shop.urssaf.form.street") }}</label>
          <input v-model.trim="form.street" class="form-control" required />
        </div>

        <div class="col-md-4">
          <label class="form-label">{{ $t("shop.urssaf.form.postalCode") }}</label>
          <input v-model.trim="form.postal_code" class="form-control" required />
        </div>

        <div class="col-md-6">
          <label class="form-label">{{ $t("shop.urssaf.form.city") }}</label>
          <input v-model.trim="form.city" class="form-control" required />
        </div>

        <div class="col-md-6">
          <label class="form-label">{{ $t("shop.urssaf.form.country") }}</label>
          <input v-model="form.country" class="form-control" />
        </div>

        <div class="col-md-6">
          <label class="form-label">{{ $t("shop.urssaf.form.dateOfBirth") }}</label>
          <input v-model="form.date_of_birth" type="date" class="form-control" required />
        </div>

        <div class="col-md-6">
          <label class="form-label">{{ $t("shop.urssaf.form.placeOfBirth") }}</label>
          <input v-model.trim="form.place_of_birth" class="form-control" required />
        </div>

        <div class="col-md-12">
          <label class="form-label">{{ $t("shop.urssaf.form.ssn") }}</label>
          <input
              v-model.trim="form.social_security_number"
              class="form-control"
              required
          />
          <div v-if="ssnError" class="text-danger mt-1">
            {{ ssnError }}
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <MDBBtn color="primary" type="button" @click="$emit('cancel')">{{ $t("global.buttons.cancel") }}</MDBBtn>
        <MDBBtn color="success" type="button" @click="onSubmit">{{ $t("shop.urssaf.form.saveAndContinue") }}</MDBBtn>
      </div>
    </form>
  </div>
</template>

<script setup>
import {
  MDBBtn,
} from "mdb-vue-ui-kit";
import {reactive, defineProps, defineEmits, ref, watch} from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const props = defineProps({
  userId: { type: Number, required: true },
  defaults: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['submit', 'cancel']);
const ssnError = ref('');

const form = reactive({
  user_id: props.userId,
  street: props.defaults.street ?? '',
  postal_code: props.defaults.postal_code ?? '',
  city: props.defaults.city ?? '',
  country: props.defaults.country ?? '',
  company_name: props.defaults.company_name ?? '',
  first_name: props.defaults.first_name ?? '',
  last_name: props.defaults.last_name ?? '',
  place_of_birth: props.defaults.place_of_birth ?? '',
  date_of_birth: props.defaults.date_of_birth ?? '',
  social_security_number: props.defaults.social_security_number ?? '',
});

watch(() => form.social_security_number, (value) => {
  ssnError.value = (value.length > 0 && (value.length !== 13 || /\D/.test(value)))
      ? t('shop.urssaf.form.errors.ssn')
      : '';
});

function onSubmit() {
  const required = [
    'user_id','street','postal_code','city','country',
    'company_name','first_name','last_name',
    'place_of_birth','date_of_birth','social_security_number'
  ];

  const missing = required.filter(k => !String(form[k] ?? '').trim());
  if (missing.length) return;

  if (form.social_security_number.length !== 13) {
    ssnError.value = t('shop.urssaf.form.errors.ssn');
    return;
  }
  emit('submit', { ...form });
}
</script>

<style scoped>
h5 { font-weight: 600; }
.text-danger { font-size: 0.875rem; }
</style>